import { EntityType } from '@/core/graphql/generated/types';

import { type LabelKey, labelKey as t } from './labelKey';

const SECTION_LABELS = {
	name: t('Name'),
	professional: t('Professional'),
	organizational: t('Organizational'),
	ids: t('IDs'),
	demographics: t('Demographics'),
	contact: t('Contact'),
	hierarchy: t('Hierarchy'),
	affiliations: t('Affiliation'),
	partners: t('Partners'),
	addresses: t('Address'),
	licenses: t('License')
} satisfies Record<string, LabelKey>;

export type SectionId = keyof typeof SECTION_LABELS;

export type SectionDef = {
	id: SectionId;
	label: LabelKey;
};

const SECTION_ORDER: Record<EntityType, readonly SectionId[]> = {
	[EntityType.Hcp]: [
		'name',
		'professional',
		'ids',
		'demographics',
		'contact',
		'affiliations',
		'addresses',
		'licenses'
	],
	[EntityType.Hco]: [
		'name',
		'organizational',
		'ids',
		'contact',
		'hierarchy',
		'affiliations',
		'partners',
		'addresses',
		'licenses'
	]
};

export const getSections = (entityType: EntityType): SectionDef[] =>
	SECTION_ORDER[entityType].map(id => ({ id, label: SECTION_LABELS[id] }));

export const getSectionLabel = (id: SectionId) => SECTION_LABELS[id];

export const getSectionIndex = (entityType: EntityType, id: SectionId) =>
	SECTION_ORDER[entityType].indexOf(id);
